import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=bb06d37a&scoped=true&"
import script from "./nav.vue?vue&type=script&lang=js&"
export * from "./nav.vue?vue&type=script&lang=js&"
import style0 from "./nav.vue?vue&type=style&index=0&id=bb06d37a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb06d37a",
  null
  
)

export default component.exports